import React from 'react'

import { CustomDropdownItemOption, DropDownItemOptionComponentProps } from '../../components/SelectDropdown/SelectDropdown'
import { TagElement } from '../../components/Tag/Tag'
import { getIntegrationColor } from '../../components/Integrations/integrationColors'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../common/integrations'

interface ContactDropdownItemProps extends DropDownItemOptionComponentProps {
  integrationServiceId: IntegrationServiceId
}

export const getContactDropdownComponent = (integrationServiceId: IntegrationServiceId) => {
  const ContactDropdownItem: React.FC<ContactDropdownItemProps> = ({ onClick, integrationServiceId, displayLabel }) => {
    const integrationColor = getIntegrationColor(integrationServiceId)
    const displayConnectorLabel = getIntegrationDisplayName(integrationServiceId)

    if (!integrationColor || !displayConnectorLabel) {
      return null
    }

    return (
      <CustomDropdownItemOption role='button' onClick={onClick}>
        <div className='d-flex align-items-center gap-2'>
          {displayLabel}
          <TagElement className='label-small' style={{ backgroundColor: integrationColor, color: '#fff' }}>
            {displayConnectorLabel}
          </TagElement>
        </div>
      </CustomDropdownItemOption>
    )
  }
  return (props: DropDownItemOptionComponentProps) => <ContactDropdownItem {...props} integrationServiceId={integrationServiceId} />
}
